import React, { Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sider from './sider';
import Menu from './menu';
import './index.scss';
import { Header } from './header';
import { useCookieState } from 'ahooks';
import { TMS_ADMIN_TOKEN } from '@/utils/constants';
import { setApiHeader } from '@/services/http/api';
import { Breadcrumb } from './breadcrumb';
import { useAccounterStore } from '@/global-store/accounter-store';

const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [token] = useCookieState(TMS_ADMIN_TOKEN);
  const { getUserInfoRequest } = useAccounterStore(() => []);
  useEffect(() => {
    if (token) {
      setApiHeader({
        Authorization: token,
      });
      getUserInfoRequest.run();
    }
  }, []);

  return (
    <div className='main_layout'>
      <Header />
      <div className='body_bar'>
        <Sider
          collapsible={true}
          collapsed={collapsed}
          onCollapse={(status) => setCollapsed(status)}
        >
          <Menu />
        </Sider>
        <div className='content_bar'>
          <Breadcrumb />
          <div className='suspense-layer'>
            <Suspense>
              <Outlet />
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
